module.exports = __webpack_public_path__ + "static/media/Logo-Digitaliza-Pyme.0c68dd2b.png";